import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PatrolAuthComponent } from '../../features/patrol/pages/patrol-auth/patrol-auth.component';
import {
  HeaderV2Component,
  NavigationButton,
} from '../../shared/components/header-v2/header-v2.component';
import { PatrolUserService } from '../../features/user/service/patrol-user.service';

const PATROL_NAV_BUTTONS: ReadonlyArray<NavigationButton> = [
  {
    icon: '/public/svgs/patrol-w.svg',
    alt: 'app.patrol.nav.setup',
    route: 'setup',
  },
  {
    icon: '/public/svgs/identity-id.svg',
    alt: 'app.patrol.nav.integration',
    route: 'integration',
  },
];

@Component({
  selector: 'app-patrol-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, PatrolAuthComponent, HeaderV2Component],
  templateUrl: './patrol-layout.component.html',
  styleUrl: './patrol-layout.component.scss',
})
export class PatrolLayoutComponent {
  private router = inject(Router);
  private patrolUserService = inject(PatrolUserService);

  public isAuthRoute = signal(false);
  public navigationButtons =
    signal<ReadonlyArray<NavigationButton>>(PATROL_NAV_BUTTONS);
  public patrolUser = this.patrolUserService.patrolUser;

  constructor() {
    this.checkRoute();
  }

  private checkRoute() {
    this.router.events.pipe(takeUntilDestroyed()).subscribe(() => {
      this.isAuthRoute.set(this.router.url.includes('/auth'));
    });
  }
}
